import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../../Common/PlaceholderWrapper";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import SearchBar from "@mnjsplatform/components/lib/common/SearchBar";
import i18next from "i18next";
import paramRender from "@mnjsplatform/components/lib/common/ParamRenderUniversal";
import RequestScheduleVacationCreatePopup from "../../Vacation/RequestScheduleVacationCreatePopup";
import ActionLink from "@mnjsplatform/components/lib/common/ActionLink";
import AuthProvider from "@mnjsplatform/data/lib/security/authProvider";
import pathJoin from "@mnjsplatform/data/lib/utils/pathJoin";
import $ from "jquery";
import {withRouter} from "react-router";
import queryString from "query-string";

class SubRequestScheduleVacationList extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            showRequestForm: null
        }
    }

    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        try {
            await this.props.dispatch(this.props.listSubForPO.reset());
            await this.props.dispatch(this.props.listSubForPO.initialize({}, {withParams: true}));
            const pageParams = queryString.parse(this.props.location.search);
            if (pageParams.id) {
                this.selectRow({SchedHolidayTransferIntId: pageParams.id, IsForBoss: 1});
            }
        } catch (e) {
            console.error(e);
        }
    }

    renderParam = (h) => {
        return (
            <>
                <div className="row mb-2">
                    <div className="col-md-4">
                        {/*Количество уровней подчиненности (<span style={{color: "red"}}>не более 5 уровней</span>):*/}
                        {h.lbl("NumSub")}
                    </div>
                    <div className="col-md-1">
                        {h.ed("NumSub")}
                    </div>
                </div>

                <div className="row mb-2">
                    <div className="col-md-12">
                        {h.ed("AdmStructName")}
                    </div>
                </div>

                <div className="row mb-2">
                    <div className="col-md-4">
                        {i18next.t("SubordinateSearch")}:
                    </div>
                    <div className="col-md-8" style={{height: "32px"}}>
                        <SearchBar dataItem={this.props.listSubForPO}/>
                    </div>
                </div>
            </>
        );
    }
    onSelectPerson = async (row, fieldInfo, e) => {
        if (fieldInfo.Name !== 'MsgCmd' && fieldInfo.Name !== 'MsgScan') {
            const rowKey = Object.assign({}, this.props.listSubForPO.getRowKey(row), {
                IsForBoss: 1,
                SelTabNum: row.TabNum
            });
            this.selectRow(rowKey);
        }
    }
    selectRow = (rowKey) => {
        this.setState({showRequestForm: true, rowKey: rowKey});
    }
    closeRequestForm = (refresh = false) => {
        this.setState({showRequestForm: false}, async () => {
            if (refresh) {
                await this.props.dispatch(this.props.listSubForPO.refresh());
            }
        })
    }
    getDocument = async (row, fieldName) => {
        const token = await AuthProvider.getToken();
        const downloadPath = pathJoin(window.config.apiRoot, "Vacation", "DownloadFile") + "?" + $.param({
            b_token: token,
            id: row.SchedHolidayTransferIntId,
            fieldName: fieldName
        });
        window.open(downloadPath, '_blank');
    }
    renderCellEx = (cellParams) => {
        if (cellParams.fieldInfo.Name === "MsgCmd") {
            return <ActionLink onSelect={async () => {
                await this.getDocument(cellParams.row, cellParams.fieldInfo.Name)
            }}>{cellParams.row.MsgCmd}</ActionLink>
        }
        if (cellParams.fieldInfo.Name === "MsgScan") {
            return <ActionLink onSelect={async () => {
                await this.getDocument(cellParams.row, cellParams.fieldInfo.Name)
            }}>{cellParams.row.MsgScan}</ActionLink>
        }
        return cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex);
    }

    render() {
        if (!this.props.listSubForPO.isInitialized)
            return null;
        let gridTitleText = i18next.t("Manager_Approve_List");
        return (
            <>
                <PlaceholderWrapper placeholderId="10"
                                    title={<><i className='fa fa-filter'/> {i18next.t("Filters")}</>}
                                    showSplitterLine={false}
                                    canCollapse={false}
                >
                    <ComplexParam dataItem={this.props.listSubForPOParams}
                                  readOnly={false}
                                  showSearchBar={true}
                                  showApplyButton={false}
                                  autoApplyParams={true}
                                  rootPath="/"
                                  parentDataItem={this.props.listSubForPO}
                                  renderParams={paramRender}
                    />
                </PlaceholderWrapper>

                <PlaceholderWrapper placeholderId="20"
                                    title={<><i className='fa fa-table'/> {gridTitleText}</>}
                                    staticTitle={i18next.t("Manager_Approve_List")}
                                    showSplitterLine={false}
                                    canCollapse={false}
                >
                    <GridView dataItem={this.props.listSubForPO} rowCursor="pointer"
                              renderCellEx={this.renderCellEx}
                              onCellClick={this.onSelectPerson}
                    />
                </PlaceholderWrapper>
                {
                    this.state.showRequestForm &&
                    <RequestScheduleVacationCreatePopup rowKey={this.state.rowKey}
                                                        onClose={this.closeRequestForm}
                                                        readOnly={false}/>
                }
            </>
        );
    }
}

SubRequestScheduleVacationList.propTypes = {
    dispatch: PropTypes.func.isRequired,
    listSubForPO: PropTypes.object,
    listSubForPOParams: PropTypes.object
}

SubRequestScheduleVacationList.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        listSubForPO: state.vacationState.SchedHolidayTransfer_ListForBossPO,
        listSubForPOParams: state.vacationState.SchedHolidayTransfer_ListForBossPO_Params
    }
}

export default withRouter(connect(mapStateToProps)(SubRequestScheduleVacationList));